<div class="dashboard-container" *ngIf="!canAccess(AppFeature.Dashboard)">
    <!-- <div class="dashboard-header">
    <h1>Client Reporting Dashboard</h1>
    <p class="dashboard-subtitle">Comprehensive sales and customer analytics</p>
  </div> -->

    <!-- <p-card styleClass="mb-3">
  <ng-template pTemplate="header">
    <span class="pi pi-calendar" style="margin-right: 0.5rem;"></span>
    <span style="font-weight: 500;">Choose Time Period</span>
  </ng-template>
  <div class="dashboard-date-filter" style="display: flex; gap: 1rem; align-items: center; margin-bottom: 0;">
<p-calendar
 [showIcon]="true"
  [(ngModel)]="fromDate"
  (onSelect)="onDateChange()"
  dateFormat="yy-mm-dd"
  placeholder="From Date">
</p-calendar>
<span>to</span>
<p-calendar
 [showIcon]="true"
  [(ngModel)]="toDate"
  [minDate]="fromDate"
  (onSelect)="onDateChange()"
  dateFormat="yy-mm-dd"
  placeholder="To Date">
</p-calendar>
213434
  </div>
    <ng-template pTemplate="right">
        <button
            pButton
            type="button"
            label="Go to Order Header"
            icon="pi pi-list"
            style="min-width: 180px; font-size: 1rem;"
            (click)="goToOrderHeader()"
        ></button>
    </ng-template>
</p-card> -->
    <p-toolbar class="dashboard-toolbar" styleClass="margin-bottom: 2rem; border-bottom: 2px solid #0ea5e9;">
        <ng-template pTemplate="header">
            <!-- <span class="pi pi-calendar" style="margin-right: 0.5rem;"></span>
    <span style="font-weight: 500;">Choose Time Period</span> -->
        </ng-template>

        <ng-template pTemplate="left">
            <!-- Sales Performance Dashboard -->
            <div style="width: 100%; display: flex; justify-content: center">
                <h1 style="font-size: 2.2rem; margin: 0">Sales Performance Dashboard</h1>
            </div>
        </ng-template>
        <ng-template pTemplate="right">
            <button pButton type="button" label="Go to Orders" icon="pi pi-list" style="min-width: 180px; font-size: 1rem" (click)="goToOrderHeader()"></button>
        </ng-template>
    </p-toolbar>
    <div class="grid" style="margin-bottom: 2rem">
        <!-- 1. Sales Report Overview -->
        <div class="col-12">
            <!-- <app-sales-report-overview [salesData]="salesReportData"></app-sales-report-overview> -->
        </div>
        <div class="col-12">
            <app-sales-person-ranking [rankingData]="salesPersonRanking"></app-sales-person-ranking>
        </div>
    </div>

    <div class="col-12" style="margin-top: 2rem; margin-bottom: 2rem">
        <p-card styleClass="summary-card">
            <div class="header-row" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem">
                <h2 style="margin: 0">Salesperson Achievement Summary</h2>

                <div class="filters" style="display: flex; align-items: center; gap: 1rem">
                    <p-selectButton [options]="dateViewOptions" [(ngModel)]="selectedView" (onChange)="onDateViewChange()" optionLabel="label" optionValue="value"></p-selectButton>

                    <!-- Show calendars only when Custom is selected -->
                    <ng-container *ngIf="selectedView === 'custom'">
                        <input id="fromDate" pInputText [(ngModel)]="fromDate" name="fromDate" type="date" class="p-inputtext p-component" style="width: 160px" (change)="onDateChange()" [max]="toDate" required />
                        <span>to</span>
                        <input id="toDate" pInputText [(ngModel)]="toDate" name="toDate" type="date" class="p-inputtext p-component" style="width: 160px" (change)="onDateChange()" [min]="fromDate" required />
                    </ng-container>
                </div>
            </div>
            <div *ngIf="!loading">
                <p-table
                    [value]="userAchievements"
                    [tableStyle]="{ 'min-width': '50rem' }"
                    responsiveLayout="scroll"
                    [stripedRows]="true"
                    *ngIf="!loading && userAchievements.length > 0"
                    [paginator]="true"
                    [rows]="10"
                    [rowsPerPageOptions]="[10, 20, 30, 50]"
                    scrollable="true"
                    scrollHeight="400px"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Salesperson</th>
                            <th>Orders Punched</th>
                            <th>Net Amount</th>
                            <th>VAT Amount</th>
                            <th>Achievement <small>(Invoiced)</small></th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-person>
                        <tr>
                            <td>{{ person.name }}</td>
                            <td>{{ person.ordersPunched }}</td>
                            <td>{{ person.netAmount | currency: 'EUR' }}</td>
                            <td>{{ person.vatAmount | currency: 'EUR' }}</td>
                            <td>{{ person.achievement | currency: 'EUR' }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="loading-container" *ngIf="loading">
                <p-progressSpinner></p-progressSpinner>
                <p>Loading User data...</p>
            </div>
            <div *ngIf="!loading && userAchievements.length === 0" class="no-data">No data available for selected range.</div>
        </p-card>
    </div>

    <div class="col-12" style="margin-top: 2rem; margin-bottom: 2rem">
        <p-card styleClass="summary-card">
            <div class="header-row" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem">
                <h2 style="margin: 0">M3 Salesperson Achievement Summary</h2>

                <div class="filters" style="display: flex; align-items: center; gap: 1rem">
                    <p-selectButton [options]="dateViewOptions" [(ngModel)]="selectedView" (onChange)="onDateViewChange()" optionLabel="label" optionValue="value"></p-selectButton>

                    <ng-container *ngIf="selectedView === 'custom'">
                        <input id="fromDateM3" pInputText [(ngModel)]="fromDate" name="fromDateM3" type="date" class="p-inputtext p-component" style="width: 160px" (change)="onDateChange()" [max]="toDate" required />
                        <span>to</span>
                        <input id="toDateM3" pInputText [(ngModel)]="toDate" name="toDateM3" type="date" class="p-inputtext p-component" style="width: 160px" (change)="onDateChange()" [min]="fromDate" required />
                    </ng-container>
                </div>
            </div>
            <div *ngIf="!loadingM3Achievements">
                <p-table
                    [value]="m3SalesAchievements"
                    [tableStyle]="{ 'min-width': '50rem' }"
                    responsiveLayout="scroll"
                    [stripedRows]="true"
                    *ngIf="!loadingM3Achievements && m3SalesAchievements.length > 0"
                    [paginator]="true"
                    [rows]="10"
                    [rowsPerPageOptions]="[10, 20, 30, 50]"
                    scrollable="true"
                    scrollHeight="400px"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th>M3 Salesperson</th>
                            <th>Orders Punched</th>
                            <th>Net Amount</th>
                            <th>VAT Amount</th>
                            <th>Achievement <small>(Invoiced)</small></th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-person>
                        <tr>
                            <td>{{ person.name }}</td>
                            <td>{{ person.ordersPunched }}</td>
                            <td>{{ person.netAmount | currency: 'EUR' }}</td>
                            <td>{{ person.vatAmount | currency: 'EUR' }}</td>
                            <td>{{ person.achievement | currency: 'EUR' }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="loading-container" *ngIf="loadingM3Achievements">
                <p-progressSpinner></p-progressSpinner>
                <p>Loading M3 salesperson data...</p>
            </div>
            <div *ngIf="!loadingM3Achievements && m3SalesAchievements.length === 0" class="no-data">No data available for selected range.</div>
        </p-card>
    </div>

    <p-toolbar class="dashboard-toolbar" styleClass="margin-bottom: 2rem; margin-top: 2rem; border-bottom: 2px solid #0ea5e9;">
        <ng-template pTemplate="left">
            <div class="dashboard-date-filter" style="display: flex; justify-content: space-between; align-items: center">
                <h2 style="margin: 0">Sales & Inventory Performance Overview</h2>
            </div>
        </ng-template>

        <ng-template pTemplate="right">
            <div class="view-mode-toggle" style="display: flex; gap: 1rem">
                <p-selectButton [options]="dateViewOptions" [(ngModel)]="selectedViewDashboard" (onChange)="onDateViewChangeDashboard()" optionLabel="label" optionValue="value"></p-selectButton>
                <ng-container *ngIf="selectedViewDashboard === 'custom'">
                    <input
                        id="fromDateDashboard"
                        pInputText
                        [(ngModel)]="fromDateDashboard"
                        name="fromDateDashboard"
                        type="date"
                        class="p-inputtext p-component"
                        style="width: 160px"
                        (change)="onDateChangeDashboard()"
                        [max]="toDateDashboard"
                        required
                    />

                    <span>to</span>

                    <input id="toDateDashboard" pInputText [(ngModel)]="toDateDashboard" name="toDateDashboard" type="date" class="p-inputtext p-component" style="width: 160px" (change)="onDateChangeDashboard()" [min]="fromDateDashboard" required />
                </ng-container>
            </div>
        </ng-template>
    </p-toolbar>
    <div class="grid" *ngIf="!loadingDashboard">
        <!-- 2. Top 5 Fast/Slow Moving Items Section -->
        <div class="col-12">
            <app-moving-items-section [fastMovingItems]="fastMovingItems" [slowMovingItems]="slowMovingItems" [errorMsg]="errorMsg"> </app-moving-items-section>
        </div>

        <!-- 3. Top 5 Customers by Revenue -->
        <div class="col-12 lg:col-6">
            <p-card header="Top 5 Customers by Revenue" styleClass="chart-card">
                <div class="chart-container" *ngIf="topCustomers.length > 0">
                    <canvas #pieChart height="250"></canvas>
                </div>
                <div class="no-data" *ngIf="topCustomers.length === 0">
                    <i class="pi pi-info-circle"></i>
                    <p>No customer data available</p>
                </div>
                <div class="chart-summary" *ngIf="topCustomers.length > 0">
                    <div class="summary-item" *ngFor="let customer of topCustomers; let i = index">
                        <div class="color-indicator" [style.background-color]="getChartColor(i)"></div>
                        <span class="customer-name">{{ customer.customerName }}</span>
                        <span class="customer-amount">{{ customer.totalAmount | currency: 'EUR' : 'symbol' }}</span>
                    </div>
                </div>
            </p-card>
        </div>

        <!-- 4. Low Moving Customers -->
        <div class="col-12 lg:col-6">
            <p-card header="Low Moving Customers" styleClass="low-customers-card">
                <div class="customers-list" *ngIf="lowMovingCustomers.length > 0">
                    <div class="customer-item" *ngFor="let customer of lowMovingCustomers; let i = index">
                        <div class="customer-rank">
                            <span class="rank-number">{{ i + 1 }}</span>
                        </div>
                        <div class="customer-details">
                            <h4>{{ customer.customerName }}</h4>
                            <div class="customer-stats">
                                <div class="stat-item">
                                    <i class="pi pi-shopping-cart"></i>
                                    <span>{{ customer.totalPlaceOrder }} orders</span>
                                </div>
                                <div class="stat-item">
                                    <i class="pi pi-dollar"></i>
                                    <span>{{ customer.totalAmount | currency: 'EUR' : 'symbol' }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="customer-status">
                            <p-tag value="Low Activity" severity="warning"></p-tag>
                        </div>
                    </div>
                </div>
                <div class="no-data" *ngIf="lowMovingCustomers.length === 0">
                    <i class="pi pi-info-circle"></i>
                    <p>No low moving customer data available</p>
                </div>
            </p-card>
        </div>

        <!-- Sales Person Ranking -->
    </div>

    <!-- Loading State -->
    <div class="loading-container" *ngIf="loading">
        <p-progressSpinner></p-progressSpinner>
        <p>Loading User data...</p>
    </div>

    <div class="loading-container" *ngIf="loadingDashboard">
        <p-progressSpinner></p-progressSpinner>
        <p>Loading dashboard data...</p>
    </div>
</div>
